import { cn } from "@/lib/utils";

const styles = {
  Base: "bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300 ring-1 ring-neutral-200 dark:ring-neutral-700",
  Pro: "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300 ring-1 ring-blue-200 dark:ring-blue-500/20",
  "Pro Advanced": "bg-purple-50 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300 ring-1 ring-purple-200 dark:ring-purple-500/20",
  Legend: "bg-primary/10 text-primary ring-1 ring-primary/30",
};

export function TierBadge({ tier, className }) {
  return (
    <span
      data-testid={`tier-badge-${tier?.replace(/\s/g, "-").toLowerCase()}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold tracking-wide uppercase",
        styles[tier] || styles.Base,
        className
      )}
    >
      {tier}
    </span>
  );
}
